export default "__VITE_ASSET__DxCP$Rgp__"